import React from 'react';

const QuickActivate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="14"
    viewBox="0 0 12 15"
    fill="none"
  >
    <path
      d="M2.25467 3.98076C3.31716 3.12947 4.63854 2.66659 6 2.66876C7.41667 2.66876 8.71867 3.15943 9.74534 3.98076L10.714 3.0121L11.6567 3.95476L10.688 4.92343C11.3931 5.80619 11.8347 6.87012 11.9619 7.99275C12.089 9.11539 11.8967 10.2511 11.4069 11.2693C10.9171 12.2874 10.1497 13.1465 9.19321 13.7478C8.23668 14.3491 7.12982 14.6681 6 14.6681C4.87018 14.6681 3.76332 14.3491 2.8068 13.7478C1.85027 13.1465 1.08296 12.2874 0.593151 11.2693C0.103347 10.2511 -0.0890385 9.11539 0.0381335 7.99275C0.165306 6.87012 0.606867 5.80619 1.312 4.92343L0.343337 3.95543L1.286 3.01276L2.25467 3.98143V3.98076ZM6 13.3354C6.61284 13.3354 7.21967 13.2147 7.78586 12.9802C8.35205 12.7457 8.8665 12.4019 9.29984 11.9686C9.73318 11.5353 10.0769 11.0208 10.3114 10.4546C10.546 9.88843 10.6667 9.2816 10.6667 8.66876C10.6667 8.05593 10.546 7.44909 10.3114 6.88291C10.0769 6.31672 9.73318 5.80227 9.29984 5.36893C8.8665 4.93559 8.35205 4.59185 7.78586 4.35732C7.21967 4.1228 6.61284 4.0021 6 4.0021C4.76233 4.0021 3.57534 4.49376 2.70017 5.36893C1.825 6.2441 1.33334 7.43109 1.33334 8.66876C1.33334 9.90644 1.825 11.0934 2.70017 11.9686C3.57534 12.8438 4.76233 13.3354 6 13.3354ZM6.66667 8.0021H8.66667L5.33334 12.3354V9.33543H3.33334L6.66667 4.99876V8.0021ZM3.33334 0.668762H8.66667V2.0021H3.33334V0.668762Z"
      fill="#6930CA"
    />
  </svg>
);

export default QuickActivate;
